export enum PosName {
  REVEL = "REVEL",
  MICROS = "MICROS",
  TEVALIS = "TEVALIS",
  FOODICS = "FOODICS",
  UNKNOWN = "UNKNOWN",
}

export enum PosIntegrator {
  REACHWARE = "Reachware",
  INHOUSE = "Inhouse",
}

export enum PosQrPattern {
  QR_CENTER = "QR Center",
  QR_AROUND = "QR Around",
}
export type PosIntegrationType =
  | "REACHWARE"
  | PosName.REVEL
  | PosName.MICROS
  | PosName.TEVALIS
  | PosName.FOODICS
  | "MOCK";

export const POS_INTEGRATORS: PosIntegrator[] = [
  PosIntegrator.REACHWARE,
  PosIntegrator.INHOUSE,
];

export const POS_QR_PATTERNS: PosQrPattern[] = [
  PosQrPattern.QR_CENTER,
  PosQrPattern.QR_AROUND,
];

export type DisablePosIntegrationRequest = {
  branchId: string;
  isEnabled: false;
  isSettlementEnabled?: boolean;
  isBillLookupEnabled?: boolean;
  isTableNumberLookupEnabled?: boolean;
  isTableIdLookupEnabled?: boolean;
  tableNumberLength?: number;
  type?: PosIntegrationType;
  integrator?: PosIntegrator;
  qrPattern?: PosQrPattern | null;
  credentials?: PosIntegrationCredentials;
  /** Opaque concurrency marker: the updatedAt this screen loaded. */
  updatedAt?: string;
};

export type PosIntegrationCredentials = {
  clientId: string;
  branchIdOnPos: string;
  tenderId: string;
  discountId: string;
  baseUrl?: string;
  withItems?: string | boolean;
  timeoutMs?: number;
  maxRetries?: number;
  autoClose?: boolean;
};

export type BindPosIntegrationRequest = {
  branchId: string;
  isEnabled: true;
  type: PosIntegrationType;
  integrator: PosIntegrator;
  qrPattern: PosQrPattern | null;
  tableNumberLength?: number;
  isSettlementEnabled?: boolean;
  isBillLookupEnabled?: boolean;
  isTableNumberLookupEnabled?: boolean;
  isTableIdLookupEnabled?: boolean;
  credentials: PosIntegrationCredentials;
  /** Opaque concurrency marker: the updatedAt this screen loaded. */
  updatedAt?: string;
};

export type UpsertPosIntegrationRequest =
  | DisablePosIntegrationRequest
  | BindPosIntegrationRequest;

export type TableIdMappingMetadata = {
  fileName: string;
  rowCount: number;
};

export type PosIntegrationResponse = {
  id: string;
  branchId: string;
  type: PosIntegrationType | string | null;
  isEnabled: boolean;
  isSettlementEnabled?: boolean;
  isBillLookupEnabled?: boolean;
  isTableNumberLookupEnabled?: boolean;
  isTableIdLookupEnabled?: boolean;
  tableIdMapping?: TableIdMappingMetadata | null;
  autoClose?: boolean;
  integrator: PosIntegrator | null;
  qrPattern: PosQrPattern | null;
  clientId?: string | null;
  branchIdOnPos?: string | null;
  tenderId?: string | null;
  discountId?: string | null;
  tableNumberLength?: number | null;
  baseUrl?: string | null;
  withItems?: string | boolean | null;
  timeoutMs?: number | null;
  maxRetries?: number | null;
  delayMs?: number | null;
  /** @deprecated Do not use */
  isScannerEnabled?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type FoodicsAuthorizationTokenResponse = {
  authorizationToken: string | null;
};
